import React, {useEffect,useState,useContext,useRef,forwardRef,useImperativeHandle} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useLocation,useSearchParams } from 'react-router-dom';
//import {news,events} from '../data'
import { LiaClockSolid } from "react-icons/lia";
import { SlLocationPin } from "react-icons/sl";
import Page from './Page';
import { PiImageThin, PiPlusBold, PiPencilSimple, PiTrashLight } from 'react-icons/pi';
import { formatDate,saveNewsItem, X_PADDING } from '../constants';
import { createRoot } from 'react-dom/client'
import Edit from './Edit';
import FileImage from './FileImage';
import { Logo } from './CoazIcons';
import YesNoDialog from './YesNoDialog';
import TextClamp from './TextClamp';
import NewsItems from './NewsItems';
import NewsItem from './NewsItem';
import NewsForm from './NewsForm';

const News = () => {
    const {mainElementRef,version,news} = useContext(GlobalContext);
    const [selected,setSelected] = useState(null);
    const [imgHeight,setImgHeight] = useState(null);
    const [hasRelated,setHasRelated] = useState(false);
    const [events,setEvents] = useState([]);
    const selectedRef = useRef(null);
    const relatedRef = useRef(null);
    const {state} = useLocation();
    const [searchParams] = useSearchParams();

    const itemId = searchParams.get("itemId");

    const onSelect = (newsItem) => {
        setSelected(newsItem);
        window.scrollTo(0,0);
    }
    
    useEffect(() => { 
        if(news && news.length > 0) {
            if(itemId) {
                let found = news.find((newsItem) => {return newsItem.ref.id == itemId});
                if(found){
                    onSelect(found);
                } else {
                    onSelect(news[0]);
                }
            } else {
                onSelect(news[0]);
            } 
        } 

        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                let rect = entry.target.getBoundingClientRect();
                setImgHeight((rect.width * 9)/16);
            }
        });

        if(selectedRef.current) {
            observer.observe(selectedRef.current);
        }

        return () => {
            observer.disconnect();
        };
    },[news,itemId]);

    return (
        <div className={`relative flex flex-col w-full h-auto`}>
            <div className='relative flex flex-col space-y-8 w-full h-auto pb-16 shrink-0'>
                <div className='flex flex-col w-full h-auto'>
                    {selected &&
                    <div className='flex flex-col space-y-8'>
                        <div className='relative flex flex-col w-full h-[80vh] shrink-0 overflow-hidden'>
                            <div className='relative w-full h-full object-cover'>
                                {selected.file?
                                    <FileImage 
                                        file={selected.file}
                                        alt="preview"
                                        className='w-full h-full object-cover'/>
                                    :
                                    <div className='w-full h-full bg-theme p-4'>
                                        <Logo  fill={"rgb(255,255,255)"}/>
                                    </div>
                                }
                                <div className={`absolute flex flex-col-reverse space-y-reverse space-y-4 top-0 left-0 bottom-0 bg-[linear-gradient(to_top,rgba(0,0,0,0.8)_0%,transparent_50%)] py-16 ${X_PADDING}`}>
                                    <p className='text-3xl lg:text-5xl text-white font-nunitoSansBold uppercase line-clamp-4 lg:line-clamp-2'>{selected.name}</p>
                                    <div className='w-1/4 h-1 rounded-full bg-theme'/>
                                </div>
                            </div>
                        </div>
                        <div className={`flex flex-col space-y-4 ${X_PADDING}`}>
                            {selected.date && selected.date instanceof Date && !isNaN(selected.date) &&
                                <span className="text-theme text-xs font-bold uppercase tracking-wider">
                                    {`${selected.date.getDate()} ${selected.date.toLocaleString('default', { month: 'long' })} ${selected.date.getFullYear()}`}
                                </span>
                            }
                            <p className='font-bold text-justify text-[#16365c] mb-2 w-full'>{selected.name}</p>
                            <p className='text-justify text-[#7c8a97]'>{selected.description}</p>
                        </div>
                    </div>
                    }
                    <NewsItems newsItems={news}/>
                </div>
            </div>
        </div>
      )
}

export default News